import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../../Base';
import { Header } from '../../Header';
import { Footer } from '../../Footer';
import Movement from "./Movement";

export default class Movements extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'movement',
            caller: props.Caller,
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 0
        };
        this.setMenuId();
        this.state.filters = {
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.refreshData();
    }
    setMenuId() {
        //this.state.menuId = ;
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Movement Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Movement Caller={this} /> });
    }
    renderForm() {
        //if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">فهرست حرکات</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="nk-content-body">
                                    <div className="nk-block-head nk-block-head-sm">
                                        <div className="nk-block-between">
                                            <div className="nk-block-head-content">
                                                <div className="nk-block-des text-soft">
                                                    <p>{this.money(this.state.data.recordsCount)} حرکت یافت شد</p>
                                                </div>
                                            </div>
                                            <div className="nk-block-head-content">
                                                <div className="toggle-wrap nk-block-tools-toggle">
                                                    <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                                    <div className="toggle-expand-content" data-content="pageMenu">
                                                        <ul className="nk-block-tools g-3">
                                                            <li>
                                                                <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span>ایجاد سطح جدید</span></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="nk-block">
                                        <div className="card card-bordered card-stretch">
                                            <div className="card-inner-group">
                                                <div className="card-inner position-relative card-tools-toggle">
                                                    <div className="card-title-group">
                                                        <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                                            <div className="form-inline flex-nowrap gx-3">
                                                                <div className="form-wrap">
                                                                    <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="عنوان سطح" className="form-control" />
                                                                </div>
                                                                <div className="btn-wrap">
                                                                    <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>

                                                {this.state.data.recordsCount <= 0 ?
                                                    <div className="card-inner-group">
                                                        <div className="example-alert">
                                                            <div className="alert alert-pro alert-warning">
                                                                <div className="alert-text">
                                                                    <h6>توجه</h6>
                                                                    <p>هیچ حرکتی یافت نشد</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="card-inner p-0">
                                                        <div className="nk-tb-list nk-tb-ulist">
                                                            <div className="nk-tb-item nk-tb-head">
                                                                <div className="nk-tb-col text-center"><span className="sub-text">عنوان</span></div>
                                                                <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                                            </div>
                                                            {this.state.data.records.map((record, index) =>
                                                                <div className="nk-tb-item">
                                                                    <div className="nk-tb-col">
                                                                        <span className="onlyMobile">عنوان: </span>
                                                                        <span className="sub-text text-center">
                                                                            <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                                                {record.title}
                                                                            </a>
                                                                        </span>
                                                                    </div>
                                                                    <div className="nk-tb-col text-end">
                                                                        <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                                            <em className="icon ni ni-cross-fill-c"></em>
                                                                        </a>
                                                                        <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                                            <em className="icon ni ni-pen"></em>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                {this.createPaging()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}